<template>
  <div :class="['payment-modal', { 'is-cn': isCN }]">
    <div class="payment-header">
      <div class="payment-header-left">
        <Img :src="avatar" alt="user-logo" class="payment-header-left-avatar" />
        <div class="payment-header-left-info">
          <div class="payment-header-left-info-name">{{ userStore.user?.account_name }}</div>
        </div>
      </div>
      <div class="payment-header-title">{{ title }}</div>
      <div class="payment-header-right">
        <div class="payment-header-right-close" @click="handleClose">
          <CloseIcon class="payment-header-right-close-icon" />
        </div>
      </div>
    </div>
    <div class="payment-content">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ModalInstance } from '@rendora/common/features/modals/factory';
import { useUserStore } from '@rendora/common/store/user';
import { getGlobalConfig } from '@rendora/common/utils/config';
import CloseIcon from '@rendora/design/assets/close.svg?component';
import { Img } from '@rendora/design/components/img/index';
import { computed, inject } from 'vue';

const isCN = getGlobalConfig().isCN;

export interface PaymentModalProps {
  title: string;
  close?: () => void;
}

const modalInstance = inject<ModalInstance>('modalInstance');
const userStore = useUserStore();
const avatar = computed(() => userStore.user?.logo_url || '');

const props = defineProps<PaymentModalProps>();

const handleClose = () => {
  console.log('handleClose', props.close, modalInstance);
  if (props.close) props.close();
  modalInstance?.close?.();
};
</script>

<style lang="scss" scoped>
.payment-modal {
  background: linear-gradient(180deg, #948dff 18.41%, #b4aeff 83.76%);
  border-radius: var(--x-radius-large);
  height: auto;
  padding: 12px 8px 8px;
  width: 100%;
  min-width: 560px;
  &.is-cn {
    min-width: 808px;
  }
}
.payment-header {
  display: flex;
  margin-bottom: 12px;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  > div {
    flex: 1;
    display: flex;
  }

  .payment-header-left {
    display: flex;
    align-items: center;
    justify-content: start;
    color: var(--x-white-1);
    line-height: 20px;
    font-size: 14px;
    padding-left: 10px;

    .payment-header-left-avatar {
      width: 26px;
      height: 26px;
      // border: 1px solid var(--x-back-2);
      border-radius: 50%;
      margin-right: 8px;
    }
  }
  .payment-header-title {
    font-size: 16px;
    color: var(--x-white-1);
    font-weight: var(--x-weight-medium);
    line-height: 28px;
    justify-content: center;
    text-align: center;
  }
  .payment-header-right {
    display: flex;
    align-items: center;
    justify-content: end;
    padding-right: 10px;
  }
}
.payment-header-right-close {
  cursor: pointer;
  color: var(--x-white-1);
  border-radius: var(--x-radius-small);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.06);
    color: var(--x-text-1);
  }
}
.payment-header-right-close-icon {
  height: 18px;
  width: 18px;
}
</style>
